import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "../../../Components/UI/Paper";
import Typography from "@mui/material/Typography";

import {
  getCountryCodes,
  getLanguageCodes,
  getServices,
  getAgreementOptionsHC,
  getBoolOptionsHC,
  getOption,
} from "API/swesum";

import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

import { ClientForm } from "Components/Client/ClientForm";
import { useClients } from "Context/Clients";
import { ClientFormData } from "utils/forms/ClientForm";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export default function CreateClient() {
  const { createClient } = useClients();
  const [formData, setFormData] = useState(ClientFormData());
  const [loading, setLoading] = useState(false);
  const [countryCodes, setCountryCodes] = useState([]);
  const [languageCodes, setLanguageCodes] = useState([]);
  const [services, setServices] = useState([]);
  const [agreementOptions, setAgreementOptions] = useState([]);
  const [boolOptions, setBoolOptions] = useState([]);

  useEffect(() => {
    const asyncFetchData = async () => {
      setLoading(true);
      const tmpCountryCodes = await getCountryCodes();
      const tmpLanguageCodes = await getLanguageCodes();
      const tmpServices = await getServices();

      const tmpAgreementOptions = await getAgreementOptionsHC();
      const tmpBoolOptions = await getBoolOptionsHC();

      const options = await getOption();
      const lastCNr = options.find((option) => option.Name === "LastCNr");
      if (lastCNr) {
        const nr = parseInt(lastCNr.Value);
        handleInputChange("CNr", `${nr + 1}`);
      }

      setCountryCodes(tmpCountryCodes);
      setLanguageCodes(tmpLanguageCodes);
      setServices(tmpServices);
      setAgreementOptions(tmpAgreementOptions);
      setBoolOptions(tmpBoolOptions);
      setLoading(false);
    };

    asyncFetchData();
  }, []);

  const { openError } = usePopupNotificationContext();

  const [tabIndex, setTabindex] = useState(0);
  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  const handleReplaceFormData = (newFormData) => {
    setFormData(newFormData);
  };

  const submit = async () => {
    const res = await createClient(formData);
    if (res.status === 201) {
      navigate(`/clients/${res.data.Id}`);
    } else {
      openError("Ett fel har uppstått", 3000);
    }
  };

  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, pt: 8, pb: 3, pl: 3, pr: 3 }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={12}>
              <Paper>
                <Typography
                  sx={{ marginBottom: "1.0rem" }}
                  variant="h5"
                  align="left"
                >
                  Skapa klient
                </Typography>
                <ClientForm
                  formData={formData}
                  handleInputChange={handleInputChange}
                  handleReplaceFormData={handleReplaceFormData}
                  countryCodes={countryCodes}
                  languageCodes={languageCodes}
                  services={services}
                  agreementOptions={agreementOptions}
                  boolOptions={boolOptions}
                  loading={loading}
                />
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 1,
                  }}
                >
                  <Button onClick={() => navigate(-1)}>Stäng</Button>
                  <Button onClick={submit} variant="contained" sx={{ ml: 3 }}>
                    Spara
                  </Button>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
